import React, { useContext, useState, useRef } from "react";
import { ensureNeighboursInArray } from "../../../helpers/arrayHelpers"
import RatingCircles from "/src/helpers/components/ratingCircles.jsx";
import "../packages/packageSearchResultItem.scss";
import { useMoneyFormatter } from "/src/helpers/Hooks/useMoneyFormatter";
import { DebugModeContext } from "/src/helpers/contexts/agentContext";
import { Tooltip, TooltipTrigger, TooltipContent } from "/src/helpers/components/tooltip.jsx";

import { useSessionStorage } from "@uidotdev/usehooks";
import { InfoIcon } from "/src/helpers/components/icons.jsx";

import { Link, useLocation } from 'react-router'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import OfficalRating from "/src/helpers/components/officalRating.jsx";
import PackageSearchResultCalendar from "../packages/searchResultItem.calendar.jsx";
import { UspFlag, uspCardStyle, uspButtonStyle } from "../components/uspBadge.jsx";

export default function HotelOnlySearchResultItem({ result }) {
    const [format, isPerPerson] = useMoneyFormatter();
    const [showCalendarModal, setShowCalendarModal] = useState(false);
    const [debugMode, umbracoAdminUrl] = useContext(DebugModeContext);
    const [lastResult, setLastResult] = useSessionStorage("last-result", null);
    let location = useLocation()
    let sliderRef = useRef(null);

    const slideCount = result.hotel.images.length;
    const [activeSlide, setActiveSlide] = useState(0);
    const [loadedSlides, setLoadedSlides] = useState(ensureNeighboursInArray(0, slideCount, []));

    const onSlideChange = (next) => {
        setActiveSlide(next);
        setLoadedSlides(ensureNeighboursInArray(next, slideCount, loadedSlides));
    };

    const previousSlide = () => {
        sliderRef.slickPrev();
    };
    const nextSlide = () => {
        sliderRef.slickNext();
    };
    const settings = {
        dots: false,
        lazyLoad: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        beforeChange: (current, next) => {
            onSlideChange(next);
        },
    };
    const usp = result.hotel.uniqueSellingPoint;
    const viewDealButtonClass = usp ? "usp-button" : "bg-primary hover:bg-secondary";

    return (<div className="search-result-card" style={uspCardStyle(usp)}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-4 lg:gap-6">
            {/* Image Slider Section */}
            <div className="h-full relative overflow-hidden rounded-xl">
                {/* Slider Container */}
                <div className="slider-container h-full">
                    <div className="relative ">
                        <UspFlag usp={usp} />
                        <Slider ref={slider => {
                            sliderRef = slider;
                        }} {...settings}>
                            {result.hotel.images.map((image, idx) => (
                                <div key={idx}>
                                    {loadedSlides.includes(idx) ?
                                        <img src={image.imageUrl + "?width=536&height=328"} alt={image.altText} className="w-full h-full object-cover" />
                                        : <></>
                                    }
                                </div>
                            ))}
                        </Slider>
                        <div className="slider-indicators">
                            <svg className="absolute right-0 bottom-0 z-[-1] hidden md:block" width="104" height="48" viewBox="0 0 104 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_6059_1066)">
                                    <path d="M16 48H0C8.83656 48 16 40.8366 16 32V48Z" fill="white" />
                                    <path d="M104 16L104 6.99382e-07C104 8.83656 96.8366 16 88 16L104 16Z" fill="white" />
                                    <path d="M16 32C16 23.1634 23.1634 16 32 16H104V48H16V32Z" fill="white" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_6059_1066">
                                        <rect width="104" height="48" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <svg className="absolute right-0 bottom-0 z-[-1] block md:hidden" width="36" height="23" viewBox="0 0 36 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_6059_13493)">
                                    <path d="M8 23H0.000976562C4.41888 22.9998 8 19.418 8 15V23Z" fill="white" />
                                    <path d="M36 8L36 3.49691e-07C36 4.41828 32.4183 8 28 8L36 8Z" fill="white" />
                                    <path d="M8 16C8 11.5817 11.5817 8 16 8H36V23H8V16Z" fill="white" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_6059_13493">
                                        <rect width="35.999" height="23" fill="white" transform="translate(0.000976562)" />
                                    </clipPath>
                                </defs>
                            </svg>


                            <button className="slider-nav slider-nav-prev hidden md:flex" onClick={previousSlide}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>

                            <span className="font-medium min-w-[1.875rem] text-[0.625rem] leading-[0.625rem] md:text-xs md:leading-normal text-center">{activeSlide + 1}/{slideCount}</span>

                            <button className="slider-nav slider-nav-next hidden md:flex" onClick={nextSlide}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>


            </div>

            {/* Content Section */}
            <div className="flex flex-col justify-between">
                <div>
                    <h3 className="flex lg:flex-row flex-col lg:items-center items-start text-2xl font-semibold text-primary mb-4">
                        <Link to={result.url} state={{ returnUrl: location.pathname + location.search, returnHotel: result.hotel.id }}>
                            {result.hotel.name}
                        </Link>
                    </h3>
                    <nav className="flex mb-4 text-sm text-content_3">
                        {result.countryName && (
                            <span>{result.countryName}</span>
                        )}
                        {result.countryName && result.regionName && (
                            <span className="mx-2">&gt;</span>
                        )}
                        {result.regionName && (
                            <span>{result.regionName}</span>
                        )}
                        {result.regionName && result.resortName && (
                            <span className="mx-2">&gt;</span>
                        )}
                        {result.countryName && !result.regionName && result.resortName && (
                            <span className="mx-2">&gt;</span>
                        )}
                        {result.resortName && (
                            <span>{result.resortName}</span>
                        )}
                    </nav>
                    {/* Ratings */}
                    <div className="flex items-center gap-4 mb-4">

                        <OfficalRating rating={result.hotel.officialRating} />


                        {result.tripadvisorRating && (
                            <div className="flex items-center gap-1">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M8.12808 13.2447C8.12808 14.4473 7.17516 15.4224 6 15.4224C4.82484 15.4224 3.87192 14.4473 3.87192 13.2447C3.87192 12.0422 4.82484 11.0669 6 11.0669C7.17516 11.0669 8.12808 12.042 8.12808 13.2447ZM17.9947 11.0669C16.8195 11.0669 15.8666 12.042 15.8666 13.2447C15.8666 14.4473 16.8194 15.4224 17.9947 15.4224C19.1701 15.4224 20.1228 14.4473 20.1228 13.2447C20.1224 12.0427 19.1704 11.0682 17.9958 11.0676L17.9947 11.0669ZM23.9947 13.2447C23.9947 16.6337 21.3074 19.3814 17.9947 19.3814C16.4836 19.3841 15.0277 18.8004 13.9204 17.7482L12 19.8857L10.0788 17.7457C8.97167 18.7993 7.51519 19.3839 6.00329 19.3816C2.69292 19.3814 0.00657434 16.6335 0.00657434 13.2445C0.00540253 12.3907 0.17881 11.5462 0.515651 10.7651C0.852491 9.98405 1.34531 9.28374 1.96244 8.70919L0 6.52415H4.36025C8.97379 3.31096 15.0375 3.31096 19.6511 6.52415H24L22.0377 8.709C22.6551 9.28347 23.1481 9.98377 23.4852 10.7649C23.8222 11.546 23.9958 12.3906 23.9947 13.2445M10.0598 13.2445C10.0598 10.9509 8.24276 9.09134 6.00146 9.09134C3.76016 9.09134 1.94308 10.951 1.94308 13.2447C1.94308 15.5383 3.76016 17.3978 6.00146 17.3978C8.24276 17.3978 10.0597 15.5388 10.0598 13.2452V13.2445ZM16.5034 7.0442C15.0763 6.43579 13.5455 6.12256 11.9995 6.12256C10.4534 6.12256 8.92264 6.43579 7.49548 7.0442C10.0576 8.04768 12.0002 10.3919 12.0002 13.1249C12.0002 10.3921 13.9424 8.04768 16.5036 7.04458L16.5034 7.0442ZM22.0542 13.2445C22.0542 10.9509 20.2371 9.09134 17.9958 9.09134C15.7545 9.09134 13.9374 10.9507 13.9374 13.2443C13.9374 15.5379 15.7543 17.3974 17.9954 17.3974C20.2366 17.3974 22.0538 15.5381 22.0538 13.2443"
                                        fill="#002B11" />
                                </svg>
                                <span className="text-md font-medium text-gray-900">{result.tripadvisorRating}</span>
                                <RatingCircles rating={result.tripadvisorRating} bgColour="bg-green-500" />
                            </div>)}
                    </div>

                    {/* Price */}
                    <div className="flex flex-col xl:flex-row items-center mb-4">
                        <div className="inline-flex items-center gap-1 px-4 py-1 rounded-full bg-tertiary text-center w-1/1 xl:w-auto   ">
                            <span className="text-xs text-secondary">from</span>
                            <span className="text-2xl font-bold ">{format(result.price, { removePostfix: true, allowShortForm: true })}</span>
                            {isPerPerson && (
                                <span className="text-xs text-secondary">pp</span>
                            )}
                            {!isPerPerson && (
                                <span className="text-xs text-secondary">Total</span>
                            )}
                        </div>
                        {
                            result.localCharges && (
                                <Tooltip>
                                    <TooltipTrigger><div className=""><InfoIcon size={30} /></div></TooltipTrigger>
                                    <TooltipContent className="bg-emp_dark text-white p-3 rounded-lg w-max max-w-sm font-thin leading-none">
                                        <p className="pb-2">An additional cost of approx. {result.localCharges.amountInPoundsFormatted} ({result.localCharges.localCurrencyFormatted}) tax will be paid locally.</p>
                                        <p className="pb-2">Based on an exchange rate of ({result.localCharges.symbol}1 {result.localCharges.currencyCode} = {result.localCharges.exchangeRate}) </p>
                                        <p className="pb-2 text-sm">Exchange rate and local taxes may change before you pay at the hotel</p>
                                    </TooltipContent>
                                </Tooltip>
                            )
                        }
                    </div>

                    {/* Features */}
                    <div className="space-y-2 mb-6">
                        <div className="flex items-center gap-2 text-content_2 justify-between">
                            <div className="flex items-center gap-2 text-content_2">
                                <svg width="24" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14 2V6M6 2V6M1 10H19M9.9955 14H10.0045M9.9955 18H10.0045M13.991 14H14M6 14H6.00897M6 18H6.00897M11 4H9C5.22876 4 3.34315 4 2.17157 5.17157C1 6.34315 1 8.22876 1 12V14C1 17.7712 1 19.6569 2.17157 20.8284C3.34315 22 5.22876 22 9 22H11C14.7712 22 16.6569 22 17.8284 20.8284C19 19.6569 19 17.7712 19 14V12C19 8.22876 19 6.34315 17.8284 5.17157C16.6569 4 14.7712 4 11 4Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <span className="text-sm">{result.startDateStr} - {result.duration} nights</span>
                            </div>
                            <div>
                                <button
                                    onClick={() => setShowCalendarModal(true)}
                                    className=" text-content_2 hover:text-content_3 ml-1 underline"
                                >
                                    <div className="flex items-center gap-2 text-content_2">
                                        <svg width="24" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14 2V6M6 2V6M1 10H19M9.9955 14H10.0045M9.9955 18H10.0045M13.991 14H14M6 14H6.00897M6 18H6.00897M11 4H9C5.22876 4 3.34315 4 2.17157 5.17157C1 6.34315 1 8.22876 1 12V14C1 17.7712 1 19.6569 2.17157 20.8284C3.34315 22 5.22876 22 9 22H11C14.7712 22 16.6569 22 17.8284 20.8284C19 19.6569 19 17.7712 19 14V12C19 8.22876 19 6.34315 17.8284 5.17157C16.6569 4 14.7712 4 11 4Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                        <span className="text-sm">View Other dates</span>
                                    </div>
                                </button>
                            </div>
                        </div>

                        {/* Room Type */}
                        <div className="flex items-center gap-2 text-content_2">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M2 3.5V20.5" stroke="currentColor" strokeWidth="1.5"
                                    strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M22 8.5V20.5" stroke="currentColor" strokeWidth="1.5"
                                    strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M2 8.5L6 10.5H22" stroke="currentColor" strokeWidth="1.5"
                                    strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M2 15.5H6M22 15.5H19" stroke="currentColor" strokeWidth="1.5"
                                    strokeLinecap="round" strokeLinejoin="round" />
                                <path
                                    d="M6 10.5V16.5C6 18.1547 6.34533 18.5 8 18.5H17C18.6547 18.5 19 18.1547 19 16.5V10.5"
                                    stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
                                    strokeLinejoin="round" />
                                <path
                                    d="M6.81362 10.5C6.89385 10.076 7.0202 9.63248 6.99567 9.19713C6.95941 8.5536 6.63697 7.96625 6.1264 7.61368C5.92478 7.47446 5.48 7.33239 5.01268 7.21093C4.3308 7.0337 3.98986 6.94508 3.59142 7.03644C3.30841 7.10133 3.06258 7.25187 2.71115 7.52079C2.67243 7.55042 2.65307 7.56523 2.62289 7.59026C2.3843 7.78812 2.17276 8.07424 2.05352 8.36034C2.03844 8.39653 2.02562 8.43102 2 8.5"
                                    stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
                                    strokeLinejoin="round" />
                            </svg>
                            <span className="text-sm">{result.rooms[0].boardBasisName}</span>
                        </div>
                    </div>
                </div>

                {/* See Availability Button */}
                <div className="flex justify-end">
                    <Link to={result.url} state={{ returnUrl: location.pathname + location.search, returnHotel: result.hotel.id }}
                        style={uspButtonStyle(usp)}
                        className={`${viewDealButtonClass} text-white text-sm px-4 py-2 rounded-full font-medium transition-colors duration-200 flex items-center gap-2 w-auto`}>
                        View deal
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </Link>
                </div>
            </div>
            {showCalendarModal && (
                <PackageSearchResultCalendar result={result} product="hotelOnly" onClose={() => setShowCalendarModal(false)} />
            )}
        </div>
        {debugMode && (
            <div className="px-4 mt-4 -mb-6 -mx-6 bg-olympic_main flex gap-6 justify-between items-center">
                <div className="bg-warning -mx-6 px-6">Debug</div>
                <div>CPR: {result.hotel.id}</div>
                <div>Source: {result.source}</div>
                <div>Ref: {result.packageReference}</div>
                {result.rooms?.some(r => r.priceBreakdown) && (
                    <Tooltip>
                        <TooltipTrigger>
                            <div className="flex items-center gap-1 cursor-help underline decoration-dotted">
                                <InfoIcon size={16} /> Price calc
                            </div>
                        </TooltipTrigger>
                        <TooltipContent className="bg-emp_dark text-white p-3 rounded-lg w-max max-w-md text-xs leading-tight">
                            <PriceBreakdownTable rooms={result.rooms} />
                        </TooltipContent>
                    </Tooltip>
                )}
                <div>Local Charges: {result.localCharges ? result.localCharges.ids.join(', ') : "N/A"}</div>
                <div><a className="text-emp hover:text-emp_dark hover:underline" target="_blank" href={umbracoAdminUrl + "/umbraco#/content/content/edit/" + result.cmsId}>Open in Umbraco</a></div>
            </div>
        )}
    </div>);
}

function PriceBreakdownTable({ rooms }) {
    const gbp = (n) => (n === null || n === undefined) ? "—" : "£" + Number(n).toFixed(2);
    const pct = (n) => (n === null || n === undefined) ? "—" : Number(n).toFixed(2) + "%";
    const Row = ({ label, value, strong }) => (
        <div className={"flex justify-between gap-6 " + (strong ? "font-semibold border-t border-white/30 pt-1 mt-1" : "")}>
            <span className="opacity-80">{label}</span>
            <span className="tabular-nums">{value}</span>
        </div>
    );

    return (
        <div className="space-y-3">
            <div className="font-semibold">Hotel-only price calculation (per room)</div>
            {rooms.filter(r => r.priceBreakdown).map((room, idx) => {
                const b = room.priceBreakdown;
                return (
                    <div key={idx} className="space-y-0.5">
                        {rooms.length > 1 && <div className="opacity-70">Room {idx + 1} — {room.boardBasisName}</div>}
                        <Row label="Dealfinder price (Package margin)" value={gbp(b.dealfinderLeadInPrice)} />
                        <Row label="− Baked-in fees (package context)" value={gbp(b.bakedInAdjustment)} />
                        <Row label="= Accommodation portion" value={gbp(b.accommodationPortion)} />
                        {b.mapped ? (
                            <Row
                                label={`Margin: Package ${pct(b.packageMargin)} → Accom-Only ${pct(b.accomOnlyMargin)} (group ${b.marginGroupId})`}
                                value={`× ${Number(b.factor).toFixed(4)}`}
                            />
                        ) : (
                            <Row label={`Unmapped — fallback adjustment ${pct(b.fallbackPercent)}`} value={`× ${Number(b.factor).toFixed(4)}`} />
                        )}
                        <Row label="= Re-margined accommodation" value={gbp(b.reMarginedAccommodation)} />
                        <Row label="+ Accom-only fees" value={gbp(b.accomOnlyAdjustment)} />
                        {b.infantSurcharge > 0 && <Row label="+ Infant surcharge" value={gbp(b.infantSurcharge)} />}
                        <Row label="= Final (lead-in)" value={gbp(b.finalPrice)} strong />
                    </div>
                );
            })}
            <div className="opacity-70 pt-1 border-t border-white/30">Card “from” price = sum of rooms, rounded per person.</div>
        </div>
    );
}
